export default "__VITE_ASSET__Dq0K2pTV__"